import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Doughnut } from 'react-chartjs-2';
import { Skeleton } from '@material-ui/lab';
import { Divider, Backdrop, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { GlobalTheme, TileTheme} from "../../layouts/theme";
import { Theme } from "../contexts/themeContext.js";
import { Context } from "../contexts/siteContext.js";
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import Card from "../card/card.js";
import CardHeader from "../card/cardHeader.js";
import CardBody from "../card/cardBody.js";
import CardContent from '@material-ui/core/CardContent';

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
        position: "absolute"
    }
}));

function getPercentage(percentage) {
    if (percentage !== null)
        return percentage.substring(0, percentage.length - 1);
    else
        return "0";
}

export default function RecoveryEVSChart(props) {
    const classes = useStyles();
    const tileClasses = TileTheme();
    const offlineService = new OfflineService();
    const { defaultSite, siteLoading } = useContext(Context);
    const { theme } = useContext(Theme);
    const [loading, setLoading] = useState(true);
    const [backDrop, setBackDrop] = useState(false);
    const [percentage, setPercentage] = useState(0);
    const [total, setTotal] = useState(0);
    const [resolved, setResolved] = useState(0);
    const currentTheme = GlobalTheme[theme];

    const getRecoveryEVSSummary = () => {
        setBackDrop(true);
        HttpService.post("/RecoveryEVS/GetRecoveryEVSSummary", {
            Date: ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite),
            SiteId: defaultSite.id
        })
        .then(async (result) => {
            if (result && result.offline) {
                let offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "RecoveryEVSSummary");
                result = offlineResult.OfflineData;
            }
            else {
                offlineService.removeOfflineBySite(defaultSite.id, "RecoveryEVSSummary");
                offlineService.addOffline(defaultSite.id, "RecoveryEVSSummary", result);
            }

            if (result.data !== null) {
                setPercentage(getPercentage(result.data.CompletionPercentage));
                setTotal(result.data.TotalRecoveries);
                setResolved(result.data.TotalResolved);
                setLoading(false);
                setBackDrop(false);
            }
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const chartData = {
        labels: ["Open", "Resolved"],
        datasets: [{
            data: [(100 - percentage), percentage],
            backgroundColor: [
                '#99CCFF',
                '#0066CC'
            ]
        }]
    };

    const options = {
        legend: {
            display: false
        },
        responsive: true,
        animation: false,
        cutoutPercentage: 70,
        layout: { padding: 0 },
        tooltips: {
            enabled: total > 0,
            callbacks: {
                title: function (tooltipItem, data) {
                    return data['labels'][tooltipItem[0]['index']];
                },
                label: function (tooltipItem, data) {
                    return data['datasets'][0]['data'][tooltipItem['index']].toString() + ' %';
                }
            }
        }
    };

    useEffect(() => {
        if (!siteLoading)
            getRecoveryEVSSummary();
        //eslint-disable-next-line 
    }, [props.mode, defaultSite, siteLoading]);


    return (<>
        <div style={{ position: "relative" }}>
            <Link to={{ pathname: "/RecoveryEVSList" }}>
                <Backdrop className={classes.backdrop} id="recoveryEVSBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Card chart color="primary" className={tileClasses.card} style={{ background: currentTheme.background, color: currentTheme.text }} >
                    <CardContent className={tileClasses.cardContent}>
                        <CardHeader>
                            <div className={tileClasses.title}>Recovery EVS</div>
                            {loading === true ? (<Skeleton variant="rect" height={76} />) : (
                                <Doughnut data={chartData} options={options} height={76} />
                            )}
                        </CardHeader>
                        <Divider />
                        <CardBody>
                            <div className={tileClasses.subTitle}>Daily Summary</div>
                            {loading === true ? (<div><Skeleton variant="text" /><Skeleton variant="text" /></div>) : (
                                <div className="d-flex flex-column">
                                    <label className={tileClasses.optionText}>Total Recoveries: {total}</label>
                                    <label className={tileClasses.optionText}>Resolved: {resolved}</label>
                                    <label className={tileClasses.optionText}>Open: {total - resolved}</label>
                                </div>
                            )}
                        </CardBody>
                    </CardContent>
                </Card>
            </Link>
        </div>
    </>
    );
}
